export default __webpack_public_path__ + "static/media/cwu14.fd65bb8e.jpeg";